import { jsx } from 'react/jsx-runtime';
import { Loader as y } from './contact-channels76.js';
import { useTranslations as $ } from './contact-channels38.js';
import { useEmail as I } from './contact-channels6.js';
import { FlexBox, Typography, tokens } from '@vp/swan';

const g=e=>{const{customTitle:t}=e,{t:n}=$(),{data:o,isLoading:r,isPending:s}=I();return jsx(y,{skeletonLines:1,skeletonLineWidths:"narrow",isLoading:r||s,children:jsx(FlexBox,{children:jsx(Typography,{fontSkin:"title-subsection",style:{color:o!=null&&o.isAvailable?void 0:tokens.SwanSemColorTextDisabled},children:t||n("email.title")})})})};

export { g as EmailHeader };
//# sourceMappingURL=contact-channels29.js.map
